import { Autocomplete, Button, Checkbox, Grid, TextField } from "@mui/material";
import { PAYMENT_STATUS_CODE } from "Components/Constants/PaymentStatusCode";
import React, { useState,useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
// import ReturnService from "../../../../Service/salesReturn.service";
import { openSnackbar } from "../../../../Redux/Actions/snackbarActions";
import invoiceService from "../../../../Service/Invoice/invoice.service";
import SalesReturnService from "../../../../Service/Invoice/SalesReturn.service";
import Loading from "../../../MUI_components/loading";
import SalesReturnTable from "./invoiceDataTable";
import ReturnDataTable from "./returnDataTable";
import Print from "../Receipt/salesReturnBill/DotMatrix"
import PosPrint from "../Receipt/salesReturnBill/posBill"

// import { useReactToPrint } from "react-to-print";
import { SALES_RETURN_TYPE } from "Components/Constants/SalesReturnType";
import BasicDialog from "Components/MUI_components/Dialog-Box/basicDialog";
import { pageStyle } from "Components/Print/printPagesStyles";
import { useReactToPrint } from "react-to-print";
import FormControl from "Components/MUI_components/FormControl/fomikFormControl";


const ReturnWithBill = (props) => {
  const { setOpen, open } = props;


  const dispatch = useDispatch();
  const stockLocations = useSelector((state) => state.location);
  //const [stock, setStock] = useState(initStockValue);
  const printComponent = React.createRef();
  const form = React.createRef();

  const [loading, setLoading] = useState(false);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [invoice, setInvoice] = useState({});
  const [returnedData, setReturnedData] = useState({}); //Already returned data
  const [invoiceForReturn, setInvoiceForReturn] = useState([]);
  const [returnedItem, setReturnedItem] = useState(null);
  const [returnedQty, setReturnedQty] = useState("");
  const [returnData, setReturnData] = useState([]);
  const [openBillPrint, setOpenBillPrint] = useState();
  const defaultLocationSelected = useSelector((state) => state.defaultLocation);
  const printType = useRef('');
    const [value, setvalue] = useState();
  const paymentTypes = useSelector((state) => state.paymentType);
  const [stock, setStock] = useState()
  const [cashPay, setCashPay] = useState(false);

  const [pageStatus, setPageStatus] = useState(
    {
      adding: true,
      recalled: false,
      editable: false
    }
  );
  const billReceiptPrintComponent = React.useRef(null);
  const computerReceiptPrintComponent = React.useRef(null);


  const handleStockDataChange = (e) => {
    const { name } = e.target;
    const { value } = e.target;

    setStock({
      ...stock,
      [name]: value,

    });
  };


  // const handlePrintDotMatrix = useReactToPrint({
  //   content: () => printComponent.current,
  //   onAfterPrint: () => {},
  // });

  //Trigger when u click on Add Icon in Returned Item
  const addingReturnedItems = (e) => {
    const { discount, totalAmount } = reverseDiscount(
      returnedItem,
      invoice.subTotalAmount,
      invoice.billDiscount,
      returnedQty

    );



    setReturnData([
      ...returnData,
      {
        itemMaster: returnedItem.itemMaster,
        unitSoldPrice: returnedItem.unitSoldPrice,
        quantity: returnedQty ? returnedQty : 1,
        discount: discount,
        totalAmount: totalAmount,
        itemCode: returnedItem.itemMaster.code,
        locationCode: defaultLocationSelected.location.code,
        costPrice: returnedItem.itemMaster.costPrice,
        retailPrice: returnedItem.itemMaster.retailPrice,
        stockCode: returnedItem.stockCode
      },
    ]);
    const temp = invoiceForReturn.map((value) =>
      value.code === returnedItem.code
        ? {
          ...value,
          quantity: value.quantity - (returnedQty ? returnedQty : 1),
        }
        : value
    );
    setInvoiceForReturn(temp);
    setReturnedItem(null);
  };

  const reverseDiscount = (selectedItem, subtotal, billDiscount) => {
    const returningQuantity = returnedQty ? returnedQty : 1

    // select sold out qty from selected invoice
    let qty = invoice.stockHistories.filter(
      (value) => value.code === selectedItem.code
    );
    const quantity = qty[0].quantity;
    const returningItemsTotalLineDiscount = (selectedItem.discountTotal / selectedItem.quantity) * returningQuantity;
    // -------------------------------
    const price =
      returnedItem.retailPrice - selectedItem.discountTotal / quantity;
    let billDiscountPortionForEachItem = (price / subtotal) * billDiscount;

    let discount =
      parseFloat(selectedItem.discountTotal / quantity) +
      parseFloat(billDiscountPortionForEachItem);
    discount = discount * (returnedQty ? returnedQty : 1);
    const totalAmount =
      returnedItem.retailPrice * (returnedQty ? returnedQty : 1) - discount;

    return { discount: discount, totalAmount: totalAmount };
  };

  const getInvoiceNumber = (e) => {
    const { value } = e.target;
    setInvoiceNumber(value);
  };

  const handleReset = () => {
    setReturnData([]);
    setInvoiceForReturn(invoice.stockHistories);
  };

  const handlePrint = useReactToPrint({

    content: () => printType.current == 'POS' ? billReceiptPrintComponent.current : computerReceiptPrintComponent.current,
        onAfterPrint: () => {
      // setInvoiceValue(initInvoice);
      // setOpen({
      //   ...open,
      //   cashPay: false,
      //   payment: false,
      //   creditPrint: false
      // });
      setPageStatus({
        ...pageStatus,
        editable: false,
        recalled: false,
        adding: true
      });
      // dispatch(getLastInsertInvoice({ code: null, date: null }));
      // fetchInvoice();
    },
    pageStyle: pageStyle.receipt,
  });

  const fetchInvoice = async () => {
    setLoading(true);
    try {
      const res = await invoiceService.get(invoiceNumber);
      console.log(res);
      setvalue(res.invoice.customer)
      setInvoice(res.invoice);
      setReturnedData(res.salesReturn);
      setInvoiceForReturn(res.invoice ? res.invoice.stockHistories : null);

      let invoiceStockHistory = res.invoice.stockHistories;
      let salesReturnStockHistory = res.salesReturn?.stockHistories;

    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
    setLoading(false);
  };

  // const handleSubmit = () => {
  const handleSubmit = async () => {
    try {
      const totalAmount = returnData
        .map((data) => data.totalAmount)
        .reduce((totalAmount, i) => totalAmount + i, 0);

      const salesReturn = {
        customerCode: invoice.customerCode,
        invoiceCode: invoice.code,
        totalAmount: totalAmount,
        paidStatus: cashPay ? PAYMENT_STATUS_CODE.CASH_PAY : PAYMENT_STATUS_CODE.PAYMENT_NOT_DONE,
        returnType: SALES_RETURN_TYPE.SALES_RETURN_WITH_BILL
      }

      const data = { ...salesReturn, returnData };
      console.log('data', data);
      await SalesReturnService.create(data);
      dispatch(
        openSnackbar(true, "success", `Sales return added successfully`)
      );
      handlePrint();
      setOpenBillPrint(false);
      setOpen({ ...open, return: false });
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }

  };


  const handleChecked = (e, target) => {
    setCashPay(target);
  };
  return (
    <>


      <br />
      <Grid container spacing={3} justify="center">
        <Grid item sm={12} xs={12}>
          <Grid container spacing={1}>
            <Grid item md={6}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                label="Invoice Number"
                value={invoiceNumber}
                onChange={getInvoiceNumber}
              />
            </Grid>
            <Grid item md={6}>
              <Button
                variant="contained"
                disabled={!invoiceNumber}
                color="primary"
                onClick={fetchInvoice}
              >
                Find
              </Button>
            </Grid>
          </Grid>
          <div className="mt mb">
            {loading ? (
              <Loading height={100} text="Loading invoice data.." />
            ) : (
              <SalesReturnTable data={invoice} returnedData={returnedData} />
            )}
          </div>
          <br />

          <form
            autoComplete="off"
            ref={form}
            onKeyPress={(e) => {
              if (e.key === "Enter")
                form.current.reportValidity() && addingReturnedItems();
            }}
          >
            <Grid container spacing={1}>
              <Grid item md={6}>
                <Autocomplete
                  options={
                    invoiceForReturn
                      ? invoiceForReturn.filter((val) => val.quantity > 0)
                      : []
                  }
                  value={returnedItem}
                  onChange={(event, newValue) => setReturnedItem(newValue)}
                  getOptionLabel={(option) =>
                    option.itemMaster?.name +
                    " - " +
                    option.itemMaster?.barcode +
                    " | Qty: " +
                    option.quantity
                  }
                  getOptionSelected={(option) => option.total}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      fullWidth
                      size="small"
                      label="Returned Item"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid item md={2}>
                <TextField
                  size="small"
                  type="number"
                  label="Qty"
                  variant="outlined"
                  inputProps={{
                    max: returnedItem && returnedItem.quantity,
                  }}
                  value={returnedQty}
                  onChange={(e) => {
                    setReturnedQty(e.target.value);
                  }}
                />
              </Grid>

              {/* <Grid item md={2}>
                        <Selects
                          label="Stock Location*"
                          options={stockLocations}
                          name="locationCode"
                          value={stock.locationCode}
                          onChange={handleStockDataChange}
                        />
              </Grid> */}

              <Grid item md={2}>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!returnedItem || returnedQty == 0 || returnedQty == ""
                    || invoice.paidStatus=="1"|| Number(returnedItem.quantity) < Number(returnedQty)}
                  onClick={() => {
                    form.current.reportValidity() && addingReturnedItems();
                  }}
                >
                  Add
                </Button>
              </Grid>
            </Grid>
          </form>
          <div className="mt mb">
            <ReturnDataTable data={returnData} />
          </div>
          <div className="flex flex-end mb">
            <Button
              variant="contained"
              color="primary"
              onClick={handleReset}
              disabled={!returnData.length}
              style={{ marginRight: 5 }}
            >
              Reset

            </Button>

            <Button

              onClick={() => {
                setOpenBillPrint(true)

              }}
              disabled={!returnData.length}
              // startIcon={
              //   props.isSubmitting && (
              //     <CircularProgress color="inherit" size={20} />
              //   )
              // }
              variant="contained"
              type="submit"
              color="secondary"
            >
              Save
            </Button>

            <BasicDialog
              title="Sales Return Bill Print"
              open={openBillPrint}

              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  handleSubmit();

                }
              }}
              onClose={(e) => setOpenBillPrint(false)}
            >
              <div>
                <span>  <Checkbox
                  label='Cash Pay'
                  onChange={handleChecked}
                />
                </span>
                <span>
                Cash Pay
                </span>

              </div>
              <div className="flex">


              
                {/* <button
                  type="button"
                  className="btn-success button"
                  onClick={() => {
                    printType.current = 'POS';
                  handleSubmit();
                  }}
                >
                  pos bill
                  <span>
                    {isSubmitting ? (
                      <CircularProgress
                        color="inherit"
                        size={20}
                      />
                    ) : (
                      "[ Enter ]"
                    )}
                  </span>
                </button> */}

                <button
                  type="button"
                  // disabled={
                  //   !cashPaymentValidity() || isSubmitting
                  // }
                  onClick={() => {
                    printType.current = 'DOT';
                    handleSubmit();

                  }}
                  className="btn-success button"
                >
                  Dot matrix bill
                  {/* <span>
                    {isSubmitting ? ( 
                       <CircularProgress
                        color="inherit"
                        size={20}
                      /> 
                      ) : (
                      ""
                    )} 
                  </span> */}
                </button>

              </div>
              <div className="flex-end">
                <Button
                  color="secondary"
                  onClick={() => {
                    setOpen({ ...open, return: false });

                    setOpenBillPrint(false)
                  }}
                >
                  Close
                </Button>
              </div>
            </BasicDialog>

            <div style={{ display: "none" }}>
              <Print
                // code={invoice.code ? invoice.code : null}
                ref={computerReceiptPrintComponent}
                returnData={returnData}
                value={value}
                invoice={invoice}
                paymentTypes={paymentTypes}
              />
              <PosPrint
                ref={billReceiptPrintComponent}
                returnData={returnData}
                value={value}
                invoice={invoice}
                paymentTypes={paymentTypes}
              />
            </div>

          </div>
        </Grid>
      </Grid>
    </>
  );
};
export default ReturnWithBill;